import { render, staticRenderFns } from "./evaluationList.vue?vue&type=template&id=2127e02e"
import script from "./evaluationList.vue?vue&type=script&lang=js"
export * from "./evaluationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports